"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = retrieveCareNotesMock;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var items = {
  startPeriod: '05/01/2020',
  endPeriod: '08/01/2021',
  notes: [{
    date: '08/02',
    age: '52 days ago',
    text: 'Voicemail left for the patient on 08/02/2020, require a call back within 48 hours.',
    id: 'foo',
    author: {
      firstName: 'Jennifer',
      lastName: 'Simpson'
    }
  }, {
    date: '08/02',
    age: '52 days ago',
    text: 'Voicemail left for the patient on 08/02/2020, require a call back within 48 hours.',
    id: 'foo',
    author: {
      firstName: 'Jennifer',
      lastName: 'Simpson'
    }
  }]
};
function retrieveCareNotesMock(_ref) {
  var resolve = _ref.resolve;
  setTimeout(function () {
    resolve(items);
  }, 1000);
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(items, "items", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/retrieve-care-notes.mock.js");
  reactHotLoader.register(retrieveCareNotesMock, "retrieveCareNotesMock", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/retrieve-care-notes.mock.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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